import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, { title: "Bemerkung bearbeiten" }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Speichern",
                onClick: _ctx.onCreate,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["onClick"]),
            _createVNode(_component_g_button, {
                text: "Abbrechen",
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_g_form, null, {
                default: _withCtx(() => [
                    _createVNode(_component_g_text_area, {
                        label: "Bemerkung",
                        "data-mode": "model",
                        "show-label": false,
                        rows: 10,
                        "data-object": _ctx.$data,
                        "data-member": "_comment"
                    }, null, 8, ["data-object"])
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
